import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutBottom: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-bottom, margin, padding"><path d="M21 16.25C21 16.4489 20.9209 16.6396 20.7803 16.7803C20.6396 16.9209 20.4489 17 20.25 17H3.75C3.33579 17 3 16.6642 3 16.25V3.75C3 3.55109 3.07907 3.36038 3.21973 3.21973C3.36038 3.07907 3.55109 3 3.75 3H20.25C20.6642 3 21 3.33579 21 3.75V16.25Z" fill="currentColor"/><path d="M21 20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25C3 19.8358 3.33579 19.5 3.75 19.5H20.25C20.6642 19.5 21 19.8358 21 20.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLayoutBottom;
